import React from 'react';

import { CLIENT_FORM } from 'src/constants/FormNames';
import { PlusSquare } from 'jbc-front/components/icons';
import BankItemSectionContainer from '../containers/BankItemSectionContainer';
import { useTranslation } from 'react-i18next';

const MAX_CLIENT_BANK = 6;

const BanksSection = props => {
  const { isNewForm, fields } = props;
  const { t } = useTranslation();
  return (
    <div>
      {fields.map((bank, index) => (
        <BankItemSectionContainer
          key={bank}
          keyIndex={index + 1}
          index={index}
          isNewForm={isNewForm}
          formKey={bank}
          formName={CLIENT_FORM}
          removable={!fields.get(index).hasEmployeePaymentBanks}
          remove={() => fields.remove(index)}
        />
      ))}

      {fields.length < MAX_CLIENT_BANK && (
        <div className="u-ta-r">
          <div role="button" tabIndex="0" onClick={() => fields.push({})} className="u-txt-addinfo">
            <PlusSquare size={20} className="u-txt-addinfo-icon" />{t('features.Clients.components.BanksSection.Add_a_new_transfe_source')}
          </div>
        </div>
      )}
    </div>
  );
};
export default BanksSection;
